 
import {
  clearMaintenanceStatus,
  getMaintenanceStatusFail,
  getMaintenanceStatusStarted,
  getMaintenanceStatusSuccess
} from '../../../reducer/schedule-maintenance/PostMaintenanceStatusReducer';
import { getPostMaintenanceStatus } from '../../actionType/schedule-maintenance/PostMaintenanceStatusTypes';
import {
  ClearGetMaintenanceStatus,
  GetMaintenanceStatusFailure,
  GetMaintenanceStatusFailurePayload,
  GetMaintenanceStatusRequest,
  GetMaintenanceStatusStarted,
  GetMaintenanceStatusSuccess,
  GetMaintenanceStatusSuccessPayload
} from '../../types/schedule-maintenance/PostMaintenanceStatusTypes';

export const getMaintenanceStatusRequest = (
  reqObject: any
): GetMaintenanceStatusRequest => ({
  type: getPostMaintenanceStatus.POST_MAINTENANCE_STATUS_REQUEST,
  requestObject: reqObject
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getMaintenanceStatusStart = (): GetMaintenanceStatusStarted => ({
  type: getMaintenanceStatusStarted.type
});

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getMaintenanceStatusSuccessful = (
  payload: GetMaintenanceStatusSuccessPayload
): GetMaintenanceStatusSuccess => ({
  type: getMaintenanceStatusSuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getMaintenanceStatusFailure = (
  payload: GetMaintenanceStatusFailurePayload
): GetMaintenanceStatusFailure => ({
  type: getMaintenanceStatusFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleargetMaintenanceStatus = (): ClearGetMaintenanceStatus => ({
  type: clearMaintenanceStatus.type
});
